


























































import {Vue, Component, Prop} from 'vue-property-decorator';
import {toI18n} from '@/utils/commonUtils';

@Component
export default class ProductsSummary extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_PRODUCTLIST_' + needToI18nStr));
  }
  @Prop({
    required: false,
    default: {
      totalCnt: 0,
      onSaleCnt: 0,
      readyCnt: 0,
      soldOutCnt: 0,
      approvalReadyCnt: 0,
      approvalRejectionCnt: 0,
      saleAgreementRejectionCnt: 0,
      stopCnt: 0,
    },
  })
  readonly data!: {};
  public selectedSummary = '';

  private setSaleStatus(event: any) {
    this.selectedSummary = event.target.getAttribute('saleStatusTypes');
    this.$emit('onClickSummarySearch', this.selectedSummary);
  }

  public resetSelect() {
    this.selectedSummary = '';
  }
}
